export default {"src":"/_next/static/media/LeftArrowBlack.a016605d.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};